import React from 'react';
import SettingsPageComponent from '../components/SettingsPage';

const SettingsPage: React.FC = () => {
  return <SettingsPageComponent />;
};

export default SettingsPage;
